/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Issue_Unknown_ReferenceInputs */

const en_reference_issue_unknown_reference = /** @type {(inputs: Reference_Issue_Unknown_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The record chosen no longer exists`)
};

/**
* | output |
* | --- |
* | "The record chosen no longer exists" |
*
* @param {Reference_Issue_Unknown_ReferenceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_issue_unknown_reference = /** @type {((inputs?: Reference_Issue_Unknown_ReferenceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Issue_Unknown_ReferenceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_issue_unknown_reference(inputs)
});